module.exports = __webpack_public_path__ + "img/removePic.61984e5a.png";